import { Inject, Injectable } from '@angular/core';
import {
  ChildActivationEnd,
  NavigationEnd,
  Router,
  Scroll,
} from '@angular/router';
import { debounceTime } from 'rxjs/operators';
import { TAG_MANAGER, TagManagerBase } from '../types';

@Injectable({
  providedIn: 'root',
})
export class TagManagerService {
  private readonly usableTagManagers: TagManagerBase[];

  constructor(
    private readonly router: Router,
    @Inject(TAG_MANAGER) private readonly tagManagers: TagManagerBase[]
  ) {
    this.usableTagManagers = this.tagManagers.filter((tm) => tm.usable());
  }

  pushTag(infos: any) {
    this.usableTagManagers.forEach((tagManager) => tagManager.pushTag(infos));
  }

  subscribeToRouterStates() {
    this.router?.events?.pipe(debounceTime(500)).subscribe((page) => {
      if (page instanceof NavigationEnd) {
        this.pushJourneyState(page?.url);
      } else if (page instanceof ChildActivationEnd) {
        this.pushJourneyState(page.snapshot['_routerState'].url);
      } else if (page instanceof Scroll) {
        this.pushJourneyState(page?.routerEvent?.url);
      }
    });
  }

  pushJourneyState(url: string) {
    this.pushTag({
      event: 'page',
      pageName: url,
    });

    switch (true) {
      case url.startsWith('/open-arrival'):
        this.pushTag({
          content_group: 'open_arrival',
        });
        break;
      case url === '/customer-declaration/glass-choice':
        this.pushTag({
          event: 'appointment_flow',
          step: '1',
          content_group: 'glass_choice',
        });
        break;
      case url === '/customer-declaration/impact-type':
        this.pushTag({
          content_group: 'glass_choice',
        });
        break;
      case url === '/customer-declaration/impact-size':
        this.pushTag({
          content_group: 'glass_choice',
        });
        break;
      case url === '/customer-declaration/field-view':
        this.pushTag({
          content_group: 'glass_choice',
        });
        break;
      case url === '/customer-declaration/license-plate':
        this.pushTag({
          content_group: 'license_plate_screen',
        });
        break;
      case url === '/customer-declaration/address':
        this.pushTag({
          event: 'appointment_flow',
          step: '2',
          content_group: 'address_screen',
        });
        break;
      case url === '/customer-declaration/appointment-search':
        this.pushTag({
          event: 'appointment_flow',
          step: '3',
          content_group: 'search_screen',
        });
        break;
      case url.startsWith('/customer-declaration/fitter/'):
        this.pushTag({
          content_group: 'fitter_details',
        });
        break;
      case url === '/customer-declaration/appointment-validation':
        this.pushTag({
          event: 'appointment_flow',
          step: '4',
          content_group: 'appointment_validation',
        });
        break;
      case url.startsWith('/customer-declaration/summary'):
        this.pushTag({
          content_group: 'confirmation_screen',
        });
        break;
      default:
        break;
    }
  }
}
